import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListNumbers16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconListNumbers16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.007 1.993v4.541a.5.5 0 0 1-1 0V3.259l-.721.172a.5.5 0 0 1-.232-.973l1.337-.318zm-.533 7.632c-.375 0-.663.242-.799.461a.5.5 0 1 1-.85-.525c.258-.42.829-.936 1.65-.936.34 0 .699.113.975.385.28.276.427.667.427 1.127 0 .798-.385 1.567-.831 2.198a8 8 0 0 1-.578.72h1.327a.5.5 0 1 1 0 1H2.25a.5.5 0 0 1-.33-.877 8.5 8.5 0 0 0 1.31-1.42c.4-.567.647-1.128.647-1.62 0-.245-.073-.36-.128-.415a.38.38 0 0 0-.275-.098M15.008 3.5a.5.5 0 0 1-.5.5H8.38a.5.5 0 0 1 0-1h6.128a.5.5 0 0 1 .5.5m-1.414 3a.5.5 0 0 1-.5.5H8.38a.5.5 0 1 1 0-1h4.714a.5.5 0 0 1 .5.5m.914 3.5a.5.5 0 1 0 0-1H8.38a.5.5 0 1 0 0 1zm-.914 2.5a.5.5 0 0 1-.5.5H8.38a.5.5 0 0 1 0-1h4.714a.5.5 0 0 1 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListNumbers16);
